import { Trans, useTranslation } from 'react-i18next';

import { ParrotLogo } from '@experimental-components/IconsComponents/ParrotLogo';

import { SuccessCard } from '@identity/presentation/components/base';

/** The channel a magic link verified. */
export type VerifiedChannel = 'email' | 'phone';

export type ChannelVerifiedConfirmationProps = {
  /** The channel the link verified. It only changes the title; the text below is the same. */
  channel?: VerifiedChannel;
};

/**
 * What the device that opened the link shows afterwards.
 *
 * It has no action on purpose: any button would continue the flow on the wrong device, since the
 * wizard is on the other one. The way to finish is to close the tab, and the text says so.
 *
 * @param {ChannelVerifiedConfirmationProps} props - Component properties
 */
export const ChannelVerifiedConfirmation = ({ channel = 'phone' }: ChannelVerifiedConfirmationProps) => {
  const { t } = useTranslation('identity');

  return (
    <div className="flex w-full items-center justify-center">
      <div
        className="flex min-h-screen max-w-125 flex-col items-center justify-center gap-6 bg-background px-6 py-10 font-sans"
        data-testid="channel-verified-confirmation"
      >
        <ParrotLogo aria-hidden className="h-16 self-center" />
        <SuccessCard
          description={<Trans components={{ strong: <strong /> }} i18nKey="identity:channelVerified.body" />}
          title={t(`channelVerified.${channel}.title`)}
        />
      </div>
    </div>
  );
};
